import { createAsyncThunk } from "@reduxjs/toolkit";
import { authSilceName } from ".";
import server from "../../../config/server";

export const loginAction = createAsyncThunk(`${authSilceName}/login`, async (credentials, thunkAPI) => {
  try {
    const response = await server.post("/login", credentials, {});
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
